import "./matching_page.css";

function MatchingPage() {
  const method: string = `1. 어르신들의 성향과 요양보호사들의 성향을 파악하여 매칭
2. 요양보호사들을 직접 찾아가서 면접하여 성향 파악 후 매칭
3. 종교적 문제로 스트레스받지 않게 매칭
4. 보호자의 요구와 이용자의 요구에 강점을 가진 요양보호사 매칭
5. 출퇴근에 있어 비교적 어려움이 없는 요양보호사 매칭
6. 기본적인 노인공경과 봉사 정신이 있는 요양보호사 매칭`;

  return (
    <div className="matching_page">
      <div className="method_container">
        <div className="method_intro">
          저희 센터는 아래와 같은 사항을 검토 후{" "}
          <div className="line_break" id="method" hidden></div>서비스를
          제공합니다
        </div>
        <br />
        <div className="method">{method}</div>
      </div>
    </div>
  );
}

export default MatchingPage;
